export default __webpack_public_path__ + "f348b2326baafa33d1138f6f9d2530b0.gif";